import React, { Component } from "react";
import logo from "../../../assets/images/loader_bg.png";
import {withToast} from "../../util/ToastService";
import "./Series.scss";
import {TigerSpinner} from "../../global/tiger-spinner/TigerSpinner";
import {GetAllSeries} from "./SeriesService";
import { Helmet } from "react-helmet";
import AllSeriesItem from "./AllSeriesItem";
import {PaginationHelp} from "../../global/pagination-help/PaginationHelp";
import {GetProfilesOfAccount} from "../profiles/ProfileService";
import {AgeQuickFilter, getAgeFilterOfProfile, getDefaultProfile, storeSelectedProfile} from "../search/AgeQuickFilter";
import {SearchInput} from "../../global/search-input/SearchInput";


class SeriesDetails extends Component {
    constructor(props) {
        super(props);
        const queryParams = new URLSearchParams(window.location.search);
        //an age given by the URL wins over the age of the selected profile
        this.ageGivenByUrl = queryParams.has("ageMin") || queryParams.has("ageMax");

        this.state = {
            loading: false,
            series: [],
            lastPage: 0,
            profiles: [],
            selectedProfile: null,
            filter: {
                page: queryParams.get("page") ? queryParams.get("page") : "",
                per_page: 20,
                sortBy: 'name',
                seriesType: queryParams.get("seriesType") ? queryParams.get("seriesType") : "",
                ageMin: queryParams.get("ageMin") ? queryParams.get("ageMin") : "",
                ageMax: queryParams.get("ageMax") ? queryParams.get("ageMax") : "",
            }
        };

    }

    async componentDidUpdate(prevProps) {
        if (prevProps.series !== this.props.series) {
            await this.loadAllSeries(0);
        } else if (prevProps.accountId !== this.props.accountId) {
            await this.loadProfiles(this.props.accountId);
            await this.loadAllSeries(0);
        }
    }

    async componentDidMount() {
        await this.loadProfiles(this.props.accountId);
        if (this.state.filter.page && this.state.filter.page > 0) {
            this.loadAllSeries(this.state.filter.page)
        } else {
            await this.loadAllSeries(0);
        }
    }

    async loadAllSeries(page) {
        this.setState({
            loading: true,
        });
        let filter = this.state.filter;
        filter.page = page;

        const response = await GetAllSeries(filter);
        if (response.error === true) {
            this.setState(prevState => ({...prevState, error: response}));
        } else {
            this.setState(prevState => ({
                ...prevState,
                loading: false,
                series: response.result,
                lastPage: Math.ceil(response.length/this.state.filter.per_page),
                filter: {...prevState.filter, page: page}}));
        }

        this.setState({
            loading: false,
        }, () => this.scrollTo());
    }

    async loadProfiles(accountId) {
        if (!accountId) {
            this.setState({profiles: [], selectedProfile: null});
            return;
        }
        const profilesResponse = await GetProfilesOfAccount(accountId);
        if (profilesResponse.error) {
            return;
        }
        const profiles = profilesResponse.result._embedded?.profiles || [];
        if (profiles.length === 0) {
            this.setState({profiles: [], selectedProfile: null});
            return;
        }
        const defaultProfile = getDefaultProfile(profiles);
        this.setState(prevState => ({
            ...prevState,
            profiles: profiles,
            selectedProfile: defaultProfile.id,
            filter: this.ageGivenByUrl ? prevState.filter : {...prevState.filter, ...getAgeFilterOfProfile(defaultProfile)},
        }));
    }

    handleSelectProfile = (selectedProfile) => {
        const profile = this.state.profiles.find(p => Number(p.id) === Number(selectedProfile));
        if (!profile) {
            return;
        }
        storeSelectedProfile(profile.id);
        this.setState(prevState => ({
            ...prevState,
            selectedProfile: profile.id,
            filter: {...prevState.filter, ...getAgeFilterOfProfile(profile)},
        }), () => this.loadAllSeries(0));
    };

    applyAgeFilter = (ageFilter) => {
        this.setState(prevState => ({...prevState, filter: {...prevState.filter, ...ageFilter}}),
                () => this.loadAllSeries(0));
    };

    renderAgeQuickFilter() {
        return (
            <AgeQuickFilter profiles={this.state.profiles}
                            selectedProfile={this.state.selectedProfile}
                            showProfiles={!!this.props.accountId}
                            ageMin={this.state.filter.ageMin}
                            ageMax={this.state.filter.ageMax}
                            onSelectProfile={this.handleSelectProfile}
                            onAgeFilterChange={this.applyAgeFilter}/>
        );
    }

    scrollTo() {
        window.scrollTo(0, 0)
        window.history.pushState({}, null, this.buildUrl(this.state.filter.page));
    }

    buildUrl(page) {
        const params = new URLSearchParams();
        if (page && Number(page) > 0) {
            params.set("page", page);
        }
        if (this.state.filter.seriesType) {
            params.set("seriesType", this.state.filter.seriesType);
        }
        //the age is always kept as soon as one is selected, so a profile based preselection survives a reload
        if (this.state.filter.ageMin !== "" && this.state.filter.ageMin != null) {
            params.set("ageMin", this.state.filter.ageMin);
        }
        if (this.state.filter.ageMax !== "" && this.state.filter.ageMax != null) {
            params.set("ageMax", this.state.filter.ageMax);
        }
        const query = params.toString();
        return "/series/all" + (query ? "?" + query : "");
    }

    handlePageClick = (event) => {
        this.setState(prevState => ({...prevState, page: event.selected}), () => this.loadAllSeries(event.selected));
    };

    hrefBuilder = (pageIndex, pageCount, selectedPage) =>  {
        if (pageIndex > pageCount) {
            pageIndex = Number(selectedPage) + 1;
        }
        return this.buildUrl(Number(pageIndex) - 1);
    };

    render() {
        const series = this.state.series;

        if(this.state.loading) {
            return (
                <div style={{width: "100%", height: "500px", textAlign: "center", fontSize: "20px"}}>
                    <br />
                    <br />
                    <br />
                    <TigerSpinner />
                    <br />
                </div>
            )
        }

        return (
                series && series.length ?
                <div>
                    <SearchInput history={this.props.history}/>
                    {this.renderAgeQuickFilter()}

                <div className="all-series-container">
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>{"Serien bei tigertones und auf der tigerbox :: tiger.media"}</title>
                        <meta name="description" content={'Alle Hörspielserien, Hörbuchserien, Künstler, Podcasts und Musiker, die im Streaming bei tigertones und auf der tigerbox verfügbar sind'} />
                        <meta name="keywords" content="Serie,Hörspiel,Podcast,Kinder,tigerbox,Musik,Hörbuch,Hörspielreihen,Hörbuchreihen,streamen,streaming" />
                    </Helmet>

                    {series.length > 0 &&
                            <>
                                <div>
                                    <div className="search-title">
                                        Alle Serien, Heldinnen und Helden
                                    </div>
                                    <hr className={"search-hr"}/>
                                </div>
                                <div className="all-series-items-container">
                                    {series.map(s => (
                                            <div className="all-series-item" key={s.id}>
                                                <AllSeriesItem series={s}/>
                                            </div>
                                    ))}
                                </div>
                                <PaginationHelp
                                        page={this.state.filter.page}
                                        totalPages={this.state.lastPage}
                                        hrefBuilder={this.hrefBuilder}
                                        handlePageClick={this.handlePageClick}
                                />
                            </>
                    }
                    </div>
                </div>
                :
                <>
                    <SearchInput history={this.props.history}/>
                    {this.renderAgeQuickFilter()}

                    <div style={{width: "100%", height: "500px", textAlign: "center", fontSize: "25px"}}>
                        <img src={logo} alt="tigermedia logo" width={100} />
                        <br />
                        <br />
                        <span style={{fontSize: "40px"}}>Keine Serien gefunden</span>
                    </div>
                </>
        );
    }
}

export default withToast(SeriesDetails);
